import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tableCell'
})

export class TableCellPipe implements PipeTransform {
  transform<T>(original: T[], cellsPerRow: number): T[][] {
    const rows: T[][] = [];
    for (let i = 0; i < original.length; i += cellsPerRow) {
      rows.push(original.slice(i, i + cellsPerRow));
    }
    return rows;
  }
}
